import { parse } from 'node-html-parser';

export const htmlDecode = (input: string): string => {
  const { text } = parse(input);
  return text;
};
